<template>
  <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path :fill="color" d="M58.42,80.49L18.36,48.04c-.87-.7-.71-2.07.3-2.55l54.37-26.17c1.16-.56,2.44.48,2.13,1.73l-14.31,58.62c-.26,1.08-1.57,1.52-2.43.82ZM57.32,68.68l9.02-36.88c.3-1.25-.98-2.29-2.14-1.73l-34.2,16.48c-1,.48-1.16,1.85-.3,2.55l7.71,6.25c.54.44,1.32.45,1.88.03l11.17-8.51c1.27-.96,2.97.42,2.29,1.86l-6,12.7c-.3.63-.13,1.39.42,1.83l7.71,6.25c.87.7,2.17.26,2.43-.82ZM56.75,71.01l-28.91-23.42,28.91,23.42Z"/>
  </svg>
</template>

<script>
export default {
  name: 'CampaingsIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
